import React from 'react';
import { observer, inject } from 'mobx-react';
import { injectIntl, intlShape } from 'react-intl';

import { Row, Col, Collapse, Button } from 'react-bootstrap';
import Lane from './Lane.jsx';
import { LANE_NAMES } from './constants';
import C3GaugeChart from '../common_components/C3GaugeChart';
import Options from './Options';
import BlockUi from '../common_components/BlockUi'

@inject('rootStore')
@inject('isPremium')
@observer
class Lanes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: true,
      fullDisplay: null
    };
  }

  componentWillMount() {
    const { rootStore } = this.props;

    rootStore.tooltipStore.setCurrentSection(rootStore.boardType);
  }

  render() {
    const { rootStore, intl } = this.props;

    return (
      <div className="react-tasks-board">
        {rootStore.requestCount > 0 && (
          <div
            className="loader-sm"
            style={{
              position: 'absolute',
              top: '25px',
              left: '25px',
              zIndex: 5
            }}
          />
        )}
        {rootStore.isTaskBoard ? this.renderTaskLanes() : this.renderCeoLanes()}
      </div>
    );
  }

  renderLane = (lane, hideAddNoteButton) => {
    if (!lane) return null;

    return (
      <Lane
        className={`lane-container lane-${lane.name}`}
        key={`lane${lane.id}`}
        lane={lane}
        hideAddNoteButton={hideAddNoteButton}
      />
    );
  };

  renderDetails = () => {
    const { rootStore, intl } = this.props;
    const { open } = this.state;

    return (
      <Row>
        <Col xs={12} md={8}>
          {!rootStore.isInclusiveBoard && (
            <div>
              <h2>{intl.formatMessage({ id: 'responsibles' })}</h2>
              {rootStore.boardMembers.length > 0 ? (
                <ul>
                  {rootStore.boardMembers.map((value, key) => (
                    <li key={key}>{value.name}</li>
                  ))}
                </ul>
              ) : (
                <h3>{intl.formatMessage({ id: 'none' })}</h3>
              )}
            </div>
          )}

          {<h3 className="bold text-center">{rootStore.title}</h3>}
          <Options />
        </Col>
        <Col xs={12} md={4}>
          <div style={{ textAlign: 'center' }}>
            <C3GaugeChart
              completeness={rootStore.completeness.tasks}
              title={intl.formatMessage({ id: 'completeness' })}
            />
          </div>
        </Col>
      </Row>
    );
  };

  renderTaskLanes = () => {
    const { rootStore, intl } = this.props;
    const { open } = this.state;

    return (
      <div className="lanes">
        <BlockUi blocking={!this.props.isPremium}>
          {rootStore.isTaskPanel && (
            <Row style={{ textAlign: 'right' }}>
              <Button
                style={{ outline: 'none' }}
                bsStyle="link"
                onClick={() => this.setState({ open: !open })}
              >
                {this.state.open
                  ? intl.formatMessage({ id: 'hide' })
                  : intl.formatMessage({ id: 'show' })}
              </Button>
            </Row>
          )}

          <Collapse in={open || !rootStore.isTaskPanel}>
            {this.renderDetails()}
          </Collapse>
          <Row>
            <Col md={4}>
              {this.renderLane(rootStore.getLaneStoreByName(LANE_NAMES.TO_DO))}
            </Col>

            <Col md={4}>
              {this.renderLane(
                rootStore.getLaneStoreByName(LANE_NAMES.DOING),
                true
              )}
            </Col>

            <Col md={4}>
              {this.renderLane(
                rootStore.getLaneStoreByName(LANE_NAMES.DONE),
                true
              )}
            </Col>
          </Row>
        </BlockUi>
      </div>
    );
  };

  renderCeoLanes = () => {
    const { rootStore, intl } = this.props;
    const buildTheProductLaneStore = rootStore.getLaneStoreByName(
      LANE_NAMES.BUILD_THE_PRODUCT
    );
    const recruitingLaneStore = rootStore.getLaneStoreByName(
      LANE_NAMES.RECRUITING
    );
    const financesLaneStore = rootStore.getLaneStoreByName(LANE_NAMES.FINANCES);
    const bmcLaneStore = rootStore.getLaneStoreByName(LANE_NAMES.BMC);

    const laneWidth = title => {
      if (title === this.state.fullDisplay) return 12;
      else if (this.state.fullDisplay === null) return 3;
      else return 4;
    };

    const lanesArray = [
      {
        title: 'ceo_build_chart_title',
        store: buildTheProductLaneStore
      },
      {
        title: 'ceo_recruiting_chart_title',
        store: recruitingLaneStore
      },
      {
        title: 'ceo_finances_chart_title',
        store: financesLaneStore
      },
      {
        title: 'ceo_bmc_chart_title',
        store: bmcLaneStore
      }
    ].sort((a, b) => {
      if (a.title === this.state.fullDisplay) return -1;
      else if (b.title === this.state.fullDisplay) return 1;
      else return 0;
    });

    return (
      <div>
        <div className="ceo-things-to-focus-container">
          <h4 className="text-center bold">
            {intl.formatMessage({ id: 'ceo-title' })}
          </h4>
          <Row>
            <Col xs={12}>
              <C3GaugeChart
                completeness={rootStore.completeness.ceo}
                title={intl.formatMessage({ id: 'ceo_general_chart_title' })}
                color={{
                  pattern: [
                    '#99CBC7',
                    '#77C2BC',
                    '#54B9B1',
                    '#32AFA5',
                    '#0FA69A'
                  ],
                  threshold: {
                    values: [20, 40, 60, 80, 100]
                  }
                }}
                size={{ height: 80 }}
                transition={{ duration: 700 }}
              />

              <Options />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} mdOffset={3} lgOffset={0} lg={4}>
              <br />
              {this.renderLane(
                rootStore.getLaneStoreByName(LANE_NAMES.TO_EXECUTE),
                true
              )}
            </Col>
            <Col xs={12} md={6} mdOffset={3} lgOffset={0} lg={4}>
              <br />
              {this.renderLane(
                rootStore.getLaneStoreByName(LANE_NAMES.DOING),
                true
              )}
            </Col>
            <Col xs={12} md={6} mdOffset={3} lgOffset={0} lg={4}>
              <br />
              {this.renderLane(
                rootStore.getLaneStoreByName(LANE_NAMES.DONE),
                true
              )}
            </Col>
          </Row>
        </div>
        <Row className="ceo-lanes-group-row">
          {lanesArray.map((item, idx) => (
            <Col key={idx} xs={12} md={6} lg={laneWidth(item.title)}>
              {this.renderLaneWithChart(item.store, item.title)}
            </Col>
          ))}
        </Row>
      </div>
    );
  };

  handleFullDisplay = title =>
    this.setState({
      fullDisplay: title === this.state.fullDisplay ? null : title
    });

  renderLaneWithChart = (laneStore, chartTitle) => {
    const { intl } = this.props;

    return (
      <div>
        <C3GaugeChart
          key={`${chartTitle}-${this.state.fullDisplay}`}
          completeness={laneStore.statistics.effectiveness}
          title={intl.formatMessage({ id: chartTitle })}
          color={{
            pattern: ['#99CBC7', '#77C2BC', '#54B9B1', '#32AFA5', '#0FA69A'],
            threshold: {
              values: [20, 40, 60, 80, 100]
            }
          }}
          size={{ height: 80 }}
          transition={{ duration: 700 }}
          hideTitle
        />
        <Row>
          <Col mdHidden xs={12}>
            <div className="text-center">
              <Button
                onClick={() => this.handleFullDisplay(chartTitle)}
                bsStyle="default"
                bsSize="small"
              >
                {intl.formatMessage({ id: 'toggle_view' })}
              </Button>
            </div>
          </Col>
        </Row>
        <hr />
        {this.renderLane(laneStore)}
      </div>
    );
  };

  componentDidMount() { }
}

Lanes.propTypes = {
  intl: intlShape.isRequired
};

export default injectIntl(Lanes);
